<div class="content">
  <div class="displayPanel">
    <fieldset class="fieldGroup">
      <legend>Model/Size Characteristics</legend>
      <div class="detailRow">
        <label class="displayLabel">Model:</label>
        <label class="displayValue">{{ candidate().modelSizeCharacteristic.modelCode }}</label>
      </div>
      <div class="detailRow">
        <label class="displayLabel">Size:</label>
        <label class="displayValue">{{ candidate().modelSizeCharacteristic.sizeCode }}</label>
      </div>
      <div class="detailRow">
        <label class="displayLabel">Width:</label>
        <label class="displayValue">{{ getDimensionValue(candidate().modelSizeCharacteristic.width) }}</label>
        <label class="configurationRatingUnitLabel">{{ getDimensionUnits() }}</label>
      </div>
      <div class="detailRow">
        <label class="displayLabel">Depth:</label>
        <label class="displayValue">{{ getDimensionValue(candidate().modelSizeCharacteristic.depth) }}</label>
        <label class="configurationRatingUnitLabel">{{ getDimensionUnits() }}</label>
      </div>
      <div class="detailRow">
        <label class="displayLabel">Height:</label>
        <label class="displayValue">{{ getDimensionValue(candidate().modelSizeCharacteristic.height) }}</label>
        <label class="configurationRatingUnitLabel">{{ getDimensionUnits() }}</label>
      </div>
      <div class="detailRow">
        <label class="displayLabel">Nominal Airflow:</label>
        <label class="displayValue">{{ getAirflowValue(candidate().modelSizeCharacteristic.nominalCfm) }}</label>
        <label class="configurationRatingUnitLabel">{{ getAirflowUnits() }}</label>
      </div>
      <div class="detailRow">
        <label class="displayLabel">Dry Weight:</label>
        <label class="displayValue">{{ getWeightValue(candidate().modelSizeCharacteristic.dryWeight) }}</label>
        <label class="configurationRatingUnitLabel">{{ getWeightUnits() }}</label>
      </div>
      <div class="detailRow">
        <label class="displayLabel">Wet Weight:</label>
        <label class="displayValue">{{ getWeightValue(candidate().modelSizeCharacteristic.wetWeight) }}</label>
        <label class="configurationRatingUnitLabel">{{ getWeightUnits() }}</label>
      </div>
      <div class="detailRow">
        <label class="displayLabel">Cost Factor:</label>
        <label class="displayValue">{{ candidate().costFactor }}</label>
      </div>
      <div class="detailRow">
        <label class="displayLabel">Target Deviation:</label>
        <label class="displayValue">{{ candidate().targetDeviation | percent: '1.1-3' }}</label>
      </div>
    </fieldset>
  </div>
  <div class="displayPanel">
    <app-candidate-rating-input [ratingRequest]="candidate().ratingRequest" [metricInput]="metricInput()">
    </app-candidate-rating-input>
  </div>
  <div class="displayPanel">
    <app-candidate-rating-output [response]="candidate().ratingResponse" [metricInput]="metricInput()" [isSureflow]="isSureflow()">
    </app-candidate-rating-output>
  </div>
</div>
